import { format } from "date-fns";

export const toISODateString = (date: Date): string =>
  format(date, "yyyy-MM-dd");
